import httpClient from "http-client/http-client";

const BASE = "v1/community-portal/master-data";

export async function getAmenityMasterList() {
  const { data, errors } = await httpClient.get({
    url: `${BASE}/amenity-master/list`,
    params: { page_size: 10000, current_page: 1 },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function getActivityMasterList() {
  const { data, errors } = await httpClient.get({
    url: `${BASE}/activity-master/list`,
    params: { page_size: 10000, current_page: 1 },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function getWhatWeDoMasterList() {
  const { data, errors } = await httpClient.get({
    url: `${BASE}/what-we-do-master/list`,
    params: { page_size: 10000, current_page: 1 },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}
